import React from "react";
import { Formik, Form, Field } from "formik";
import { Row, Col } from "reactstrap";
import { Button } from "zina-dogi-react";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { service as costpackageService } from "../redux";

import "./costpackage_filter.scss";

const filterVal = (key, val) => {
    return costpackageService
        .getCostpackages(1, {
            ...(val !== "" ? { [`${key}__icontains`]: val } : {})
        })
        .then(resp =>
            resp.list.map(val => {
                return {
                    value: val[key],
                    label: val[key]
                };
            })
        );
};

const CostPackageFilter = ({ className, onSubmit = () => {}, ...props }) => {
    const comp_op = {
        className: ["costpackage_filters", className].join(" ")
    };
    const header = (
        <nav className="navbar">
            <span className="navbar-brand h4">Cost package Management</span>
        </nav>
    );
    props.setheader(header);
    return (
        <div {...comp_op}>
            <div className="content">
                <Formik
                    initialValues={{
                        code: null,
                        name: null,
                        cancelled: null
                    }}
                    enableReinitialize={true}
                    onSubmit={(values, cmp) => handleSubmit(onSubmit, values, cmp)}
                >
                    {props => {
                        const { values, setFieldValue } = props;
                        return (
                            <Form>
                                <Row>
                                    <Col sm="12" md="4">
                                        <div className="form-group">
                                            <label>Cost Package Description</label>
                                            <Field
                                                name="name"
                                                value={values.name}
                                                component={AsyncSelect}
                                                isClearable
                                                cacheOptions
                                                defaultOptions
                                                loadOptions={val => filterVal("name", val)}
                                                onChange={val => setFieldValue("name", val, false)}
                                            />
                                        </div>
                                    </Col>
                                    <Col sm="12" md="4">
                                        <div className="form-group">
                                            <label>Cost Package Code</label>
                                            <Field
                                                name="code"
                                                value={values.code}
                                                component={AsyncSelect}
                                                isClearable
                                                cacheOptions
                                                defaultOptions
                                                loadOptions={val => filterVal("code", val)}
                                                onChange={val => setFieldValue("code", val, false)}
                                            />
                                        </div>
                                    </Col>
                                    <Col sm="12" md="4">
                                        <div className="form-group">
                                            <label>Cost Package Status</label>
                                            <Field
                                                component={Select}
                                                name="cancelled"
                                                value={values.cancelled}
                                                options={[
                                                    {
                                                        value: "True",
                                                        label: "Cancelled"
                                                    },
                                                    {
                                                        value: "False",
                                                        label: "Active"
                                                    }
                                                ]}
                                                onChange={val => setFieldValue("cancelled", val, false)}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                <div className="controls">
                                    <Button type="reset" color="danger" icon="sync-alt">
                                        Clear filters
                                    </Button>
                                    <Button type="submit" color="primary" icon="filter">
                                        Filter
                                    </Button>
                                </div>
                            </Form>
                        );
                    }}
                </Formik>
            </div>
        </div>
    );
};

const handleSubmit = (submit, obj, { setSubmitting }) => {
    const computeValue = key => (obj[key] ? { [key]: obj[key].value } : {});
    submit({
        ...computeValue("name"),
        ...computeValue("code"),
        ...computeValue("cancelled")
    });
    setSubmitting(false);
};

export default CostPackageFilter;
